export default __webpack_public_path__ + "static/media/about-fablab-2.0e640cf8.jpg";